import React from 'react';
import { useContentful } from '../contentful/ContentContext';
import Page from './Page';

const HomePage = () => {
  const { getEntriesByType } = useContentful();
  const pages = getEntriesByType('page').sort(
    (a, b) => a.fields.navigationOrder - b.fields.navigationOrder
  );

  return (
    <>
      {pages.map((page) => (
        <Page key={page.sys.id} pageId={page.fields.id} />
      ))}
    </>
  );
};

export default HomePage;
